import { Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";

function BatteryMarkers({ batteries = [], activeBattery }) {
  const map = useMap();

  useEffect(() => {
    if (activeBattery) {
      map.flyTo(activeBattery.location.coordinates, 15, {
        animate: true,
      });
    }
  }, [activeBattery]);

  return batteries.map((battery, idx) => {
    if (!battery.location?.coordinates) {
      return null;
    }
    const icon = new L.DivIcon({
      className: "my-div-icon",
      html:
        '<img src="/assets/imgs/battery.png" style="width:20px;height:20px;"/>' +
        `<span style="background-color:#000;color:#fff;font-weight:bold;">${battery.battery_number}</span>`,
    });
    return (
      <Marker icon={icon} key={idx} position={battery.location.coordinates}>
        <Popup>
          Battery Number <br /> <a>{battery.battery_number}</a>.
        </Popup>
      </Marker>
    );
  });
}

export default BatteryMarkers;
